export default __webpack_public_path__ + "c3ea022485272ec2f3760dc49815f904.jpeg";